import { Locales } from '../enum/locales';
import { TLocales } from '../type/locales';
import { IReadSurah } from '../interfaces/i-read-surah';

export const readSurahListFields: (keyof IReadSurah)[] = [
  'slug',
  'index',
  'title_en',
  'transliteration',
  'title_ar',
  'page',
];

export class ReadSurah {
  id: number;
  slug: string;
  index: number;
  page: number;
  start: string;
  titleEn: string;
  titleAr: string;
  history: string;
  transliteration: string;

  constructor(data: IReadSurah, locale: TLocales | string = Locales.en) {
    this.id = data.id;
    this.slug = data.slug;
    this.titleEn = data.title_en;
    this.titleAr = data.title_ar;
    this.index = data.index;
    this.page = data.page;
    this.start = data.start;
    this.history = data.history;
    this.transliteration = data.transliteration;
  }
}
